<template>
  <div
    class="global-settings"
    :style="`position:absolute;width:100%;height:${dispH}px;padding-bottom: 120px`"
  >
    <Calibration
      :style="`position:absolute;width:100%;height:${dispH}px;padding-bottom:120px;z-index:1;`"
      v-if="isCalibrationShow"
      @closeCalibration="isCalibrationShow = false"
    ></Calibration>
    <el-container style="height: 100%">
      <el-aside width="500px">
        <el-menu
          :default-active="currentSetting"
          background-color="#2d3039"
          text-color="#409eff"
          active-text-color="#409eff"
          @select="handleSelect"
        >
          <div style="width: 100%; text-align: center; margin-top: 20px; font-size: 30px">
            <h1>{{ $t("langcfg.txtSettings") }}</h1>
          </div>
          <el-menu-item class="menu-item" index="exit">
            <i class="iconfont icon-left menu-item-unselected">&nbsp;{{ $t("langcfg.txtExit") }}</i>
          </el-menu-item>
          <el-menu-item class="menu-item" index="language">
            <i class="iconfont icon-language menu-item-unselected"
              >&nbsp;{{ $t("langcfg.txtLanguage") }}</i
            >
          </el-menu-item>
          <el-menu-item class="menu-item" index="dateFormat">
            <i class="iconfont icon-calendar menu-item-unselected"
              >&nbsp;{{ $t("langcfg.txtDateFormat") }}</i
            >
          </el-menu-item>
          <el-menu-item class="menu-item" index="wifi">
            <i class="iconfont icon-Wifi menu-item-unselected"
              >&nbsp;{{ $t("langcfg.txtNetwork") }}</i
            >
          </el-menu-item>
          <el-menu-item class="menu-item" index="login">
            <i class="iconfont icon--log-in menu-item-unselected"
              >&nbsp;{{ $t("langcfg.txtLogin") }}</i
            >
          </el-menu-item>
          <el-menu-item class="menu-item" index="account">
            <i class="iconfont icon-users menu-item-unselected"
              >&nbsp;{{ $t("langcfg.txtLoginAccount") }}</i
            >
          </el-menu-item>
          <el-menu-item class="menu-item" index="dicom">
            <i class="iconfont icon-server menu-item-unselected">&nbsp;DICOM</i>
          </el-menu-item>
          <el-menu-item class="menu-item" index="shot">
            <i class="iconfont icon-camera menu-item-unselected"
              >&nbsp;{{ $t("langcfg.txtCaptureSettings") }}</i
            >
          </el-menu-item>
          <el-menu-item class="menu-item" index="topography" v-if="isTopographyEnabled">
            <div
              :style="`width:30px;height:30px;background:url(${mapIcon});display:inline-block;background-size: cover;  `"
            ></div>
            <i class="iconfont menu-item-unselected" style="padding-left: 10px">
              {{ $t("langcfg.txtTopography") }}
            </i>
          </el-menu-item>
          <el-menu-item class="menu-item" index="print">
            <i class="iconfont icon-baogao menu-item-unselected"
              >&nbsp;{{ $t("langcfg.txtReport") }}</i
            >
          </el-menu-item>
          <el-menu-item class="menu-item" index="storage">
            <i class="iconfont icon-harddriveyingpan menu-item-unselected"
              >&nbsp;{{ $t("langcfg.txtStorage") + diskText }}</i
            >
          </el-menu-item>
          <el-menu-item class="menu-item" index="timeZone">
            <i class="iconfont icon-shiqudechuli menu-item-unselected"
              >&nbsp;{{ $t("langcfg.txtTimeAndZone") }}</i
            >
          </el-menu-item>
          <el-menu-item class="menu-item" index="about" @click.native="showCalibration">
            <i class="iconfont icon-guanyu menu-item-unselected"
              >&nbsp;{{ $t("langcfg.txtAbout") }}</i
            >
          </el-menu-item>
          <!-- <el-menu-item  class="menu-item" index="restore">
            <i class="iconfont icon-liuchenghuifu menu-item-unselected"
              >&nbsp;{{ $t('langcfg.txtRestoreSettings') }}
            </i>
          </el-menu-item>-->
        </el-menu>
      </el-aside>
      <el-main>
        <div class="setting-main" :style="mainStyle">
          <About
            v-if="currentSetting === 'about'"
            :isUpdate="isUpdate"
            @close-update-tip="closeUpdateTip"
          />
          <!--          <Language v-if="currentSetting === 'language'"-->
          <Language
            v-show="currentSetting === 'language'"
            @change-language="$emit('change-language')"
            :isKeyboardLoading="isKeyboardLoading"
          />
          <!--<DateFormat v-if="currentSetting === 'dateFormat'" />-->
          <DateFormat v-show="currentSetting === 'dateFormat'" />
          <Login v-if="currentSetting === 'login'" />
          <Account v-if="currentSetting === 'account'" @re-login="relogin" />
          <PrintSettings v-if="currentSetting === 'print'" @update="printSettingsUpdate = true" />
          <!--<Dicom v-if="currentSetting === 'dicom'" />-->
          <Dicom v-show="currentSetting === 'dicom'" />
          <!--          <Topography v-if="currentSetting === 'topography'" />-->
          <Topography v-show="currentSetting === 'topography'" />
          <!--          <Storage v-if="currentSetting === 'storage'" :diskUsage="diskUsage" :percent="percent" />-->
          <Storage
            v-show="currentSetting === 'storage'"
            :diskUsage="diskUsage"
            :percent="percent"
            :usbDriver="usbDriver"
            @check-usbdriver="checkUsbdriver"
          />
          <!--          <Storage-->
          <!--            v-if="currentSetting === 'storage'"-->
          <!--            :diskUsage="diskUsage"-->
          <!--            :percent="percent"-->
          <!--          />-->
          <Wifi v-if="currentSetting === 'wifi'" />
          <Shot v-if="currentSetting === 'shot'" />
          <time-zone v-if="currentSetting === 'timeZone'" />
        </div>
      </el-main>
      <!-- <button v-if="!isPowerringoff" class="poweroff" @click="showPowerOff">
        <span class="el-icon-switch-button"></span>
      </button>
      <PowerOff v-if="isPowerringoff" @poweroffCancel="poweroffCancel" />-->
    </el-container>

    <div class="dev-tool" @click="callDevTool"></div>
    <div class="ip-tool" v-show="currentSetting === 'language'" @click="showIP">
      {{ ip }}
    </div>
  </div>
</template>
<script>
import About from "./settings/About";
import Language from "./settings/Language";
import DateFormat from "./settings/DateFormat";
import Account from "./settings/Account";
import Login from "./settings/Login";
import PrintSettings from "./settings/PrintSettings";
import PowerOff from "./settings/PowerOff";
import Dicom from "./settings/Dicom";
import Topography from "./settings/Topography";
import Storage from "./settings/Storage";
import Wifi from "./settings/Wifi";
import Shot from "./settings/Shot";
import TimeZone from "./settings/TimeZone";
import { License, Size } from "../../mixins";
import { restoreAllSettings } from "../../settings";
import fileSys from "../../fileoprators/fileSystem";
import { isLinux } from "../../shared/utils";
import Calibration from "../../topography/components/Calibration.vue";
const exec = window.require("child_process").exec;
let _currentSetting = "language";
export default {
  name: "GSettings",
  data() {
    return {
      currentSetting: "language",
      isPowerringoff: false,
      mapIconSelected: require("../../assets/img/map_selected.png"),
      mapIconUnselected: require("../../assets/img/map_unselected.png"),
      mapIcon: require("../../assets/img/map_unselected.png"),
      percent: 0,
      ip: "",
      isCalibrationShow: false,
      printSettingsUpdate: false,
      count: 0,
      isUpdate: false,
      dispCnt: 0,
      ipCnt: 0
    };
  },
  components: {
    Language,
    DateFormat,
    Account,
    PrintSettings,
    About,
    PowerOff,
    Dicom,
    Topography,
    Storage,
    Wifi,
    Shot,
    TimeZone,
    Login,
    Calibration
  },
  created() {
    fileSys.getFreeSpace("/dev/sda6", (volumeSize, percent) => {
      this.diskUsage = volumeSize;
      this.percent = percent;
      this.ipCnt = 0;
      this.dispCnt = 0;
    });
  },
  mixins: [Size, License],
  methods: {
    checkUsbdriver(result) {
      this.$emit("check-usbdriver", result);
    },
    closeUpdateTip() {
      this.isUpdate = false;
      this.$emit("close-update-tip");
    },
    relogin() {
      this.$emit("re-login");
    },
    callDevTool() {
      this.dispCnt++;
      if (this.dispCnt >= 8) {
        this.dispCnt = 0;
        fileSys.openTools();
      }
    },
    showIP() {
      this.ip = "";
      this.ipCnt++;
      if (this.ipCnt >= 10) {
        let cmd = isLinux() ? "ifconfig|grep inet" : "ipconfig";
        exec(cmd, (err, data) => {
          console.log("error:", err);
          this.ip = data.toString();
        });
      }
    },
    poweroffCancel() {
      this.isPowerringoff = false;
    },
    showPowerOff() {
      this.isPowerringoff = true;
    },
    handleSelect(key) {
      this.currentSetting = key;
      if (key !== "about") {
        this.count = 0;
      }
      switch (key) {
        // 退出按钮
        case "exit":
          this.$emit("input", false); // 传参隐藏本组件
          if (this.mode === "blink" || this.mode === "nibut") {
            this.$bus.$emit("initCam", this.mode);
          }
          // if (
          //   this.currentPage === "capture" &&
          //   (this.mode !== "topography" || this.mode !== "pupilcorneadia")
          // )
          //   this.$bus.$emit("lampInit", this.mode);
          if (this.currentPage === "capture") {
            if (this.mode === "topography" && window.topographyState) {
              this.$bus.$emit("lampInit", `topography_${window.topographyState}`);
            } else if (this.mode === "pupilcorneadia" && window.pupilCorneaState) {
              this.$bus.$emit("lampInit", window.pupilCorneaState);
            } else {
              this.$bus.$emit("lampInit", this.mode);
            }
          }
          if (this.mode === "questionnaire" && window.settings.language === "de") {
            this.$bus.$emit("exit-de");
          }
          if (
            this.currentPage === "topography" &&
            this.mode === "report" &&
            this.printSettingsUpdate
          ) {
            this.$bus.$emit("exit-report");
          }
          this.ip = "";
          this.ipCnt = 0;
          this.mapIcon = this.mapIconUnselected;
          if (
            this.currentPage === "dryeye" &&
            (this.mode === "nibut" ||
              this.mode === "lipidlayer" ||
              this.mode === "fbut" ||
              this.mode === "blink")
          ) {
            this.$bus.$emit("add-keydown");
          }
          setTimeout(() => {
            this.currentSetting = _currentSetting;
          }, 500);
          break;
        case "topography":
          this.mapIcon = this.mapIconSelected;
          _currentSetting = key;
          break;
        case "restore":
          restoreAllSettings();
          break;
        default:
          _currentSetting = key;
          this.mapIcon = this.mapIconUnselected;
          break;
      }
    },
    showCalibration() {
      this.count += 1;
      if (this.count >= 6) {
        this.$emit("back-to-patientmanager");
        this.count = 0;
        setTimeout(() => {
          this.isCalibrationShow = true;
        }, 100);
      }
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    isKeyboardLoading: {
      type: Boolean,
      default: false
    },
    refresCnt: {
      type: Number,
      default: 0
    },
    mode: {
      type: String,
      default: ""
    },
    currentPage: {
      type: String,
      default: ""
    },
    curSetting: {
      type: String,
      default: undefined
    },
    usbDriver: {
      type: Object,
      default: () => {
        return { status: false };
      }
    }
  },
  mounted() {
    let flag = !!(this.curSetting && this.curSetting !== "");
    this.currentSetting = !flag ? this.currentSetting : this.curSetting;
    this.isUpdate = flag && window.updateSettings.isUpdateTipVisible;
    this.dispCnt = 0;
  },
  watch: {
    value: function () {
      if (this.value) {
        this.handleSelect(_currentSetting);
      } else {
        this.printSettingsUpdate = false;
      }
    },
    refresCnt: function () {
      this.dispCnt = 0;
      this.ipCnt = 0;
      if (
        this.currentPage === "dryeye" &&
        (this.mode === "nibut" ||
          this.mode === "lipidlayer" ||
          this.mode === "fbut" ||
          this.mode === "blink")
      ) {
        this.$bus.$emit("remove-keydown");
      }
      fileSys.getUDiskInfo((result) => {
        this.$emit("check-usbdriver", result);
      });
    },
    isCalibrationShow: function () {
      global.isCalibrationShow = this.isCalibrationShow;
    }
  },
  computed: {
    diskText() {
      return this.percent >= 95 ? `(${this.$t("langcfg.txtFull")})` : "";
    },
    mainStyle() {
      if (
        this.currentSetting === "login" ||
        this.currentSetting === "about" ||
        this.currentSetting === "account" ||
        this.currentSetting === "storage" ||
        this.currentSetting === "timeZone"
      ) {
        return "justify-content: center;align-items: center;";
      } else {
        return "justify-content: left;align-items: flex-start;";
      }
    }
  }
};
</script>
<style lang="less" scoped>
.global-settings {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 70;
  background: #2d3039;
  z-index: 999;
}
.setting-main {
  display: flex;
  height: 100%;
}
.el-menu {
  height: 100%;
  text-align: left;
  padding-left: 15px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.el-menu-item {
  display: flex;
  align-items: center;
  height: 100%;
  font-size: @header-fs+5;
  i {
    font-size: @header-fs+5;
    font-style: normal;
  }
  border-bottom: 1px solid rgba(gray, 0.3);
}
.el-main {
  height: 100%;
}
h5 {
  color: white;
  text-align: center;
}
.div-split {
  width: 100%;
  height: 50px;
}
.menu-item-unselected {
  color: white;
}

.poweroff {
  position: absolute;
  right: 35px;
  bottom: 50px;
  font-size: 22px;
  width: 80px;
  height: 80px;
  z-index: 99;
  background: rgba(0, 0, 0, 0.3);
  clip-path: circle(50%);
  border: none;
  outline: none;
  font-size: 45px;
}
.dev-tool {
  width: 300px;
  height: 200px;
  position: fixed;
  right: 0px;
  top: 0px;
}
.ip-tool {
  width: 300px;
  height: 500px;
  position: fixed;
  right: 10px;
  top: 400px;
  overflow: auto;
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/GSettings.vue